// src/features/wf2/popup/W2DateErrorModal.jsx
import React from "react";
import "./W2DateErrorModal.css";

export default function W2DateErrorModal({ open, message = "Data não pode ser no passado.", onClose }) {
  if (!open) return null;
  return (
    <div className="w2date-backdrop" onClick={onClose}>
      <div className="w2date-modal" onClick={(e) => e.stopPropagation()}>
        <div className="w2date-title">Data inválida</div>
        <div className="w2date-msg">{message}</div>
        <button className="w2date-btn" type="button" onClick={onClose}>
          Fechar
        </button>
      </div>
    </div>
  );
}

